export default {
  isLogin: false,
  loginShow: false,
  userImage: '',
  frompage : '',
	cdjsID: 0,
  cdCode: '',
  showLabels: false,
  refreshLabels: 0,
  pointsDetailId: 0,
}



// WEBPACK FOOTER //
// ./src/vuex/state.js